const strings = {
  'prizes/hockeyChallenge/blurb': {
    en: "If your NHL players score,<br/> you'll win a sweet daily prize!",
    fr: 'Si vos joueurs de la LNH marquent des buts, vous gagnez un délicieux prix quotidien!',
  },
  'prizes/hockeyChallenge/1/title': {
    en: 'If 1 of your picks score,',
    fr: 'Si 1 de vos joueurs marque un but,',
  },
  'prizes/hockeyChallenge/2/title': {
    en: 'If 2 of your picks score,',
    fr: 'Si 2 de vos joueurs marquent chacun un but,',
  },
  'prizes/hockeyChallenge/3/title': {
    en: 'If 3 of your picks score,',
    fr: 'Si 3 de vos joueurs marquent chacun un but,',
  },
  'prizes/hockeyChallenge/1/reward': {
    en: 'Win 25 Tims Rewards Points',
    fr: 'Vous gagnez 25 points FidéliTim',
  },
  'prizes/hockeyChallenge/2/reward': {
    en: 'Win 50 Tims Rewards Points',
    fr: 'Vous gagnez 50 points FidéliTim',
  },
  'prizes/hockeyChallenge/3/reward': {
    en: 'Win 100 Tims Rewards Points',
    fr: 'Vous gagnez 100 points FidéliTim',
  },
  'prizes/hockeyChallenge/pointHeader/or': {
    en: 'or',
    fr: 'ou',
  },
  'prizes/hockeyChallenge/pointHeader/an': {
    en: 'an',
    fr: 'une',
  },
  'prizes/hockeyChallenge/pointHeader/offer': {
    en: 'Offer',
    fr: 'Offre',
  },
  'prizes/hockeyChallenge/pointHeader/points': {
    en: 'points',
    fr: 'Points',
  },
};

export default strings;
